export default __webpack_public_path__ + "static/media/bitnoa.898db4cc.png";